import { GalaxyFilterOperator } from './enums';

export const SEARCH_DEBOUNCE_MS = 300;

export const FILTER_RANGE_OPERATORS = [
  GalaxyFilterOperator.FILTER_OPERATOR_IS_BETWEEN,
  GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_BETWEEN,
];
